import { render } from "./SimulatedRequest.vue?vue&type=template&id=9f03715c&scoped=true"
import script from "./SimulatedRequest.vue?vue&type=script&lang=js"
export * from "./SimulatedRequest.vue?vue&type=script&lang=js"

import "./SimulatedRequest.vue?vue&type=style&index=0&id=9f03715c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9f03715c"

export default script